import { RouteProps } from 'react-router';
import Switch from './index';
import SwitchSuccess from './switch-success';
import SwitchInvestment from './SwitchInvestment';
import SwitchOtp from './SwitchOtp';
import SwitchTo from './SwitchTo';
import { SwitchPaths } from './types';

const Routes: RouteProps[] = [
    {
        path: SwitchPaths.Switch,
        component: Switch,
        exact: true,
    },
    {
        path: SwitchPaths.SwitchOtp,
        component: SwitchOtp,
    },
    {
        path: SwitchPaths.SwitchTo,
        component: SwitchTo,
    },
    {
        path: SwitchPaths.SwitchChangeRequest,
        component: SwitchInvestment,
    },
    {
        path: SwitchPaths.SwitchSuccess,
        component: SwitchSuccess,
    },
];

export { Routes as SwitchRoutes };
